@for (share of shares; track share) {
  <app-share-class-type-label [securityType]="share.securityType" [hidePrice]="hidePrice">
    <span [hidden]="hideQuantity"> - </span>
    <span class="quantity" [hidden]="hideQuantity">[{{ share.number }} shares]</span>
  </app-share-class-type-label>
}
